export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13322.b4c3d357.jpg";